<template>
  <div class="row">
    <div class="col-12">
      <b-form v-if="isFormInit" @submit="onSubmit">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="order-number" :label="'order_number' | i18n" label-for="order-number-input">
              <b-form-input id="order-number-input" v-model="formData.orderDefaultNumber" size="sm" trim />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="angebot" :label="'order_type_full' | i18n" label-for="angebot-input">
              <b-form-select id="angebot-input" v-model="formData.offer" :options="offerTypes" size="sm" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group :label="'order_date' | i18n" label-for="order-date-input">
              <date-time-picker v-model="formData.createdDate" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="order-delivery-date" :label="'date_of_delivery' | i18n" label-for="order-delivery-date-input">
              <b-input-group size="sm">
                <datepicker
                  id="order-delivery-date-input"
                  ref="dateOfDeliveryCalendar"
                  v-model="formData.dateOfDelivery"
                  format="dd.MM.yyyy"
                  :language="languages[lng]"
                  :bootstrap-styling="true"
                  :typeable="true"
                  input-class="form-control-sm"
                  calendar-class="rp-calendar"
                />
                <b-input-group-append>
                  <b-button variant="outline-primary" class="btn-calendar-addon" size="sm" @click="openCalendar('dateOfDeliveryCalendar')">
                    <img :src="calendarIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="customer-number" :label="'customer_number' | i18n" label-for="customer-number-input">
              <b-form-input id="customer-number-input" v-model="formData.customerNumber" size="sm" trim />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="name1" :label="'name1' | i18n" label-for="name1-input">
              <b-form-input id="name1-input" v-model="formData.name1" size="sm" trim />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="name2" :label="'name2' | i18n" label-for="name2-input">
              <b-form-input id="name2-input" v-model="formData.name2" size="sm" trim />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="matchcode" :label="'customer_matchcode' | i18n" label-for="matchcode-input">
              <b-form-input id="matchcode-input" v-model="formData.matchcode" size="sm" trim />
            </b-form-group>
          </div>

          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="street" :label="'street' | i18n" label-for="street-input">
              <b-form-input id="street-input" v-model="formData.street" size="sm" trim />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="zip" :label="'zip_short' | i18n" label-for="zip-input">
              <b-form-input id="zip-input" v-model="formData.zip" size="sm" trim />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="city" :label="'city' | i18n" label-for="city-input">
              <b-form-input id="city-input" v-model="formData.city" size="sm" trim />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="state" :label="'state' | i18n" label-for="state-input">
              <b-form-input id="state-input" v-model="formData.state" size="sm" trim />
            </b-form-group>
          </div>

          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="order-info1" :label="'information' | i18n" label-for="order-info1-input">
              <b-form-input id="order-info1-input" v-model="formData.information1" size="sm" trim />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="order-info2" :label="'reference' | i18n" label-for="order-info2-input">
              <b-form-input id="order-info2-input" v-model="formData.information2" size="sm" trim />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="order-details" :label="'ordering_information' | i18n" label-for="order-details-input">
              <b-form-textarea id="order-details-input" v-model="formData.details" size="sm" rows="3" max-rows="3" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="order-text" :label="'order_text' | i18n" label-for="order-text-input">
              <b-form-textarea id="order-text-input" v-model="formData.orderText" size="sm" rows="3" max-rows="3" trim />
            </b-form-group>
          </div>

          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="agent" :label="'representative' | i18n" label-for="agent-input">
              <b-form-input id="agent-input" v-model="formData.salesRepresentative" size="sm" trim />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="value-days" :label="'value_days' | i18n" label-for="value-days-input">
              <b-form-input id="value-days-input" v-model="formData.valueDays" size="sm" trim />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <b-form-group id="exported" :label="'exported' | i18n" label-for="checkbox-exported">
              <b-form-checkbox id="checkbox-exported" v-model="formData.isExported" inline :checked="formData.isExported" name="checkbox-exported" />
            </b-form-group>
          </div>
        </div>
        <div class="row justify-content-end form-buttons">
          <div class="col-12">
            <b-form-group class="form-button-group">
              <b-button type="submit" variant="primary" size="sm">
                {{ 'save' | i18n }}
              </b-button>
              <b-button variant="outline-primary" class="btn-cancel" size="sm" @click="cancelEdit">
                {{ 'abort' | i18n }}
              </b-button>
            </b-form-group>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { BFormTextarea } from 'bootstrap-vue';
import { OrderMixin, NotificationMixin } from '../../mixins';
import Datepicker from 'vuejs-datepicker';
import { de, en } from 'vuejs-datepicker/dist/locale';
import calendarIcon from '../../assets/icons/calendar.svg';
import DateTimePicker from '../inputs/date-time-picker';
import { ORDER_OFFER_TYPES } from '../../../../../constants';

export default {
  name: 'EditOrder',
  components: { DateTimePicker, Datepicker, BFormTextarea },
  mixins: [OrderMixin, NotificationMixin],
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {
      formData: {
        createdDate: null,
        createdDateString: null,
        createdDateTimeString: null
      },
      offerTypes: ORDER_OFFER_TYPES.map(t => ({ value: t.value, text: t.name })),
      languages: {
        de,
        en
      },
      isFormInit: false,
      calendarIcon
    };
  },
  computed: {
    modalTitle: function() {
      return `${this.$translate('order')} ${this.order.orderDefaultNumber}`;
    }
  },
  created() {
    if (this.order) {
      this.formData = this.mapFormData(this.order);
      this.isFormInit = true;
    } else {
      this.loadOrder(this.$route.params.id);
    }
  },
  methods: {
    async loadOrder(id) {
      try {
        const response = await this.orderService.getOrderById(id);
        this.formData = this.mapFormData(response.order);
        this.isFormInit = true;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    mapFormData(order) {
      return {
        id: order.id,
        orderDefaultNumber: order.orderDefaultNumber,
        customerNumber: order.customerNumber,
        name1: order.name1,
        name2: order.name2,
        information1: order.information1,
        information2: order.information2,
        orderText: order.orderText,
        printRequested: order.printRequested,
        details: order.details,
        valueDays: order.valueDays,
        city: order.city,
        state: order.state,
        street: order.street,
        zip: order.zip,
        matchcode: order.matchcode,
        salesRepresentative: order.salesRepresentative,
        isExported: order.isExported,
        createdDate: new Date(order.createdDate * 1000),
        dateOfDelivery: order.dateOfDelivery ? new Date(order.dateOfDelivery * 1000) : 0,
        offer: order.offer
      };
    },
    async onSubmit(event) {
      event.preventDefault();
      try {
        const requestBody = this.getRequestBody();
        await this.orderService.updateOrder(requestBody);
        this.showNotification({ type: 'success', title: this.$translate('order_edit'), message: this.$translate('order_edit_success') });
        this.$emit('saved');
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    cancelEdit() {
      this.$emit('cancel');
    },
    getRequestBody() {
      const requestBody = { ...this.formData };
      requestBody.createdDate = requestBody.createdDate.getTime() / 1000;
      requestBody.dateOfDelivery = requestBody.dateOfDelivery instanceof Date ? requestBody.dateOfDelivery.getTime() / 1000 : 0;
      return requestBody;
    },
    openCalendar(ref) {
      this.$refs[ref].showCalendar();
    }
  }
};
</script>

<style scoped lang="scss">
* {
  font-size: 0.875rem;
}

.form-buttons {
  .btn:first-child {
    margin-right: 10px;
  }
}

@media (max-width: 768px) {
  .form-buttons .btn {
    margin: 0;
  }
}

@media (min-width: 768px) {
  .form-buttons .form-group {
    float: right;
  }
}

.vdp-datepicker {
  flex: 1 1 0%;
}

::v-deep   .custom-checkbox {
  padding-left: 0;
  position: absolute;
  top: 38%;
}
</style>
